import { type Dispatch, type SetStateAction, useState } from 'react'

import {
  type OfferV11,
  type PimProductWithVariantsV1,
  type RxByPrincipleReasonSet,
  type RxByPrincipleSelectableReason,
} from '@redteclab/api/clients/bully'

import { useProductPageApiSwrFetchCartMetadata } from '../api/swr/useProductPageApiSwrFetchCartMetadata'

export type RxByPrincipleControls =
  | {
      isReasonRequired: boolean
      queryParamName: `rxByPrincipleReason[${string}]`
      reasonSet: RxByPrincipleReasonSet
      selectedReason?: RxByPrincipleSelectableReason
      setSelectedReason: Dispatch<
        SetStateAction<RxByPrincipleSelectableReason | undefined>
      >
    }
  | {
      isReasonRequired: false
    }

export const useRxByPrincipleControls = ({
  currentOffer,
  product,
}: {
  currentOffer?: OfferV11
  product: PimProductWithVariantsV1
}): RxByPrincipleControls => {
  const offerId = currentOffer?.offerId

  const reasonSet = product.rx_by_principle?.reason_set

  const { data } = useProductPageApiSwrFetchCartMetadata({
    disabled: !offerId || !reasonSet,
  })

  const reasonAlreadyProvided = Boolean(
    offerId &&
      data?.rxByPrinciple?.offerIdsWithAlreadySelectedReasons?.includes(
        offerId,
      ),
  )

  const [selectedReason, setSelectedReason] =
    useState<RxByPrincipleSelectableReason>()

  if (offerId && reasonSet && !reasonAlreadyProvided) {
    return {
      isReasonRequired: true,
      queryParamName: `rxByPrincipleReason[${offerId}]`,
      reasonSet,
      selectedReason,
      setSelectedReason,
    }
  }

  return {
    isReasonRequired: false,
  }
}
